// --- Attributes ---
export const ATTR_PRESSED = 'pressed';

// --- States (Internal/CSS) ---
export const STATE_PRESSED = 'pressed';

// --- Events ---
export const EVENT_PRESSED = 'pressed'; // Suffix, voir ElementChangedEvent
